import userConstants from '../user/constants';
import { constants as appConstants } from '../app';

/**
 * @type {Object} The initial state.
 */
export const initialState = {
  token: false,
  connected: true, // Start with true to prevent the "disconnect" message on start.
};

/**
 * @type {Object} constants used to modify the state.
 */
export const constants = {
  connected: 'SOCKET/CONNECTED',
};

/**
 * A reducer to modify the state.
 *
 * @param {Object} state The current state.
 * @param {string} type The action type.
 * @param {*} payload The action payload.
 *
 * @returns {Object} The updated state.
 */
export default (state = initialState, { type, payload } = {}) => {
  switch (type) {
    // Set the connection state.
    case constants.connected:
      return {
        ...state,
        connected: payload,
      };

    case userConstants.login:
      return {
        ...state,
        token: payload.token ? payload.token.accessToken : false,
      };

    case userConstants.closeCustomer:
      return { ...state, token: false };

    case appConstants.setSessionExpired:
    case userConstants.logout:
      return initialState;

    // Return the current state.
    default:
      return state;
  }
};
